<template>
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :show-close="false"
        :center="false"
        :title="title"
        :visible.sync="dialogVisible"
        :width="width"
        v-on:close="handleClose"
    >
        <!-- 插槽：自定义对话框内容 -->
        <slot name="content"></slot>
        <div></div>
        <div v-if="copywritingDisplay && $cache.getCompanyInfoParam('25101611') == '1'" class="top">
            根据《金融机构客户身份证识别和客户身份资料及交易记录保存管理办法》，为了您的账户安全，请上传开户证件,否则您的以下交易将被限制
        </div>
        <div v-else class="top">
            根据《金融机构客户身份证识别和客户身份资料及交易记录保存管理办法》，为了您的账户安全，请上传开户证件
        </div>
        <div
            v-if="copywritingDisplay && $cache.getCompanyInfoParam('25101611') == '1'"
            class="restricting-copywriting"
        >
            <p v-if="$cache.getCompanyInfoParam('25101613')">
                买入类交易:
                {{
                    getDisplayNames(
                        $cache.getCompanyInfoParam("25101613"),
                        $cache.getDict("25101601")
                    )
                }}
            </p>
            <p v-if="$cache.getCompanyInfoParam('25101614')">
                卖出类交易:
                {{
                    getDisplayNames(
                        $cache.getCompanyInfoParam("25101614"),
                        $cache.getDict("25101602")
                    )
                }}
            </p>
        </div>
        <div class="tips">本次操作预计占用您20秒时间，请尽快完善</div>

        <!-- 底部按钮区 -->
        <div slot="footer" class="dialog-footer">
            <el-button v-on:click="handleCancel">暂不完善</el-button>
            <el-button type="primary" v-on:click="handleConfirm">马上完善</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "DialogChild",
    props: {
        title: { type: String, default: "温馨提示" },
        width: { type: String, default: "50%" },
        // 控制对话框显示/隐藏（.sync修饰符语法糖）
        dialogVisible: { type: Boolean, default: false },
        // 交易控制文案
        copywritingDisplay: { type: Boolean, default: true }
    },
    methods: {
        // 关闭对话框（通知父组件更新状态）
        handleClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 取消按钮
        handleCancel() {
            this.handleClose();
            this.$emit("cancel"); // 触发取消事件
        },
        // 确认按钮
        handleConfirm() {
            this.handleClose();
            this.$router.push({ name: "modifyinfo" });
            this.$emit("confirm"); // 触发确认事件
        },
        getDisplayNames(inputStr, dictionary) {
            if (!inputStr || !dictionary) return "";

            // 创建高性能映射表
            const codeMap = new Map(dictionary.map((item) => [item.subitem, item.subitemname]));

            return (
                inputStr
                    .split(",")
                    .map((code) => code.trim()) // 去除前后空格
                    .filter((code) => code) // 过滤空值
                    .map((code) => codeMap.get(code) || null) // 允许显示null
                    .filter(Boolean) // 过滤null和undefined
                    .join("、") || "暂无数据"
            ); // 空值兜底
        }
    }
};
</script>
<style lang="scss" scoped>
.top {
    font-size: 15px;
    color: #333333;
    line-height: 22px;
    margin-bottom: 20px;
}
.restricting-copywriting {
    margin-left: 30px;
    text-align: left;
}
.tips {
    margin-top: 20px;
    color: #c3c3c3;
    text-align: center;
}
:deep(.el-dialog__footer) {
    text-align: center;
}
</style>
